import { render, staticRenderFns } from "./OrderShare.vue?vue&type=template&id=e98e6c6e&"
import script from "./OrderShare.vue?vue&type=script&lang=js&"
export * from "./OrderShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports